export default function Contact() {
  return (
    <section>
      <div className="container">
        <h2 className="bg-dark text-center text-uppercase text-secondary mt-5 mb-5">
          Contact Me
        </h2>
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto">
            <form id="contactForm" name="sentMessage">
              <div className="control-group">
                <div className="form-group floating-label-form-group controls mb-0 pb-2">
                  <input
                    className="form-control"
                    id="name"
                    type="text"
                    placeholder="Name"
                    required="required"
                    data-validation-required-message="Please enter your name."
                  />
                  <p className="help-block text-danger"></p>
                </div>
              </div>
              <div className="control-group">
                <div className="form-group floating-label-form-group controls mb-0 pb-2">
                  <input
                    className="form-control"
                    id="email"
                    type="email"
                    placeholder="Email Address"
                    required="required"
                    data-validation-required-message="Please enter your email address."
                  />
                  <p className="help-block text-danger"></p>
                </div>
              </div>
              <div className="control-group">
                <div className="form-group floating-label-form-group controls mb-0 pb-2">
                  <input
                    className="form-control"
                    id="phone"
                    type="tel"
                    placeholder="Phone Number"
                    required="required"
                    data-validation-required-message="Please enter your phone number."
                  />
                  <p className="help-block text-danger"></p>
                </div>
              </div>
              <div className="control-group">
                <div className="form-group floating-label-form-group controls mb-0 pb-2">
                  <textarea
                    className="form-control"
                    id="message"
                    rows="5"
                    placeholder="Message"
                    required="required"
                    data-validation-required-message="Please enter a message."
                  />
                  <p className="help-block text-danger"></p>
                </div>
              </div>

              <div className="form-group">
                <button
                  className="btn btn-block btn-primary btn-xl"
                  id="sendMessageButton"
                  type="submit"
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
